// Module
var code = "<div class=\"kov-pro-illustration-list-item\"> <div class=\"list-item-info\"> <a class=\"list-item-info__title\"> <h5 compile=\"example.title\"></h5> </a> <div class=\"kov-pro-blogitem__info-excerpt\"> <ws-theme-text s-item=\"::ctrl.sItem\" s-color=\"::ctrl.sColor\"></ws-theme-text> </div> </div> </div>";
// Exports
module.exports = code;